export const HOUSEHOLD = {
  periodicity: "",
  imported_name: "",
  info_note: "",
  categories: null,
  persons: [
    {
      first_name: "",
      last_name: "",
      email: "",
      salutation: "",
      gender: "",
      is_child: 0,
      is_jewish: 0,
      info_note: "",
      isMain: false,
      set_as_main: 0,
      phones: [
        {
          number: "",
          type: "",
          area_code: "",
          country: "",
        },
      ],
      addresses: [
        {
          country: "",
          state: "",
          city: "",
          street_type: "",
          street_name: "",
          unit_number: "",
          apartment_number: "",
          zip_code: "",
          latitude: "",
          longitude: "",
          place_id: "",
          // A contact address is always a Work address now (the home address is
          // household-owned, in Home details). The UI has no type selector, yet the
          // Yup addressSchema requires `type` once an address is entered — so default
          // it here, matching addAddress(), or a filled work address can never validate.
          type: "Work",
          info_note: "",
          fullAddress: "",
          set_as_household_address: false,
          is_manual: false,
          routing_latitude: "",
          routing_longitude: "",
          include_in_optimize: null,
          is_do_not_visit: false,
        },
      ],
    },
  ],
  // The household-OWNED house phone shown/edited in the home-details header. Submitted at
  // the household level (not nested under a contact).
  housePhone: {
    number: "",
    type: "Home",
    area_code: "",
    country: "",
  },
  // The household-OWNED home address shown/edited in the home-details header. Submitted at
  // the household level (not nested under a contact).
  homeAddress: {
    country: "",
    state: "",
    city: "",
    street_type: "",
    street_name: "",
    unit_number: "",
    apartment_number: "",
    zip_code: "",
    latitude: "",
    longitude: "",
    place_id: "",
    type: "Home",
    info_note: "",
    formatted_address: "",
    fullAddress: "",
    set_as_household_address: false,
    is_manual: false,
    routing_latitude: "",
    routing_longitude: "",
    include_in_optimize: null,
    is_do_not_visit: false,
  },
}

export const PERSON = {
  first_name: "",
  last_name: "",
  email: "",
  salutation: "",
  gender: "",
  is_child: 0,
  is_jewish: 0,
  info_note: "",
  set_as_main: 0,
  phones: [
    {
      number: "",
      type: "",
      area_code: "",
      country: "",
    },
    {
      number: "",
      type: "",
      area_code: "",
      country: "",
    },
    {
      number: "",
      type: "",
      area_code: "",
      country: "",
    },
    {
      number: "",
      type: "",
      area_code: "",
      country: "",
    },
  ],
  addresses: [
    {
      country: "",
      state: "",
      city: "",
      street_type: "",
      street_name: "",
      unit_number: "",
      zip_code: "",
      latitude: "",
      longitude: "",
      place_id: "",
      // Contact addresses are always Work addresses and the UI has no type selector,
      // yet addressSchema requires `type` once an address is entered — default it so an
      // added contact's address can validate (mirrors HOUSEHOLD + addAddress()).
      type: "Work",
      info_note: "",
      set_as_household_address: false,
      is_do_not_visit: false,
    },
  ],
}

export const ADDRESS = {
  country: "",
  state: "",
  city: "",
  street_type: "",
  street_name: "",
  unit_number: "",
  apartment_number: "",
  zip_code: "",
  latitude: "",
  longitude: "",
  place_id: "",
  type: "",
  info_note: "",
  set_as_household_address: false,
  is_manual: false,
  routing_latitude: "",
  routing_longitude: "",
  include_in_optimize: null,
  is_do_not_visit: false,
}

export const VISITS_ADDRESS = {
  id: "",
  country: "",
  state: "",
  city: "",
  street_type: "",
  street_name: "",
  unit_number: "",
  apartment_number: "",
  zip_code: "",
  latitude: "",
  longitude: "",
  place_id: "",
  person_id: "",
  type: "",
  info_note: "",
  isMain: "",
  fullAddress: "",
  created_at: "",
  updated_at: "",
  new_address: "",
  is_manual: false,
  routing_latitude: "",
  routing_longitude: "",
  include_in_optimize: null,
  is_do_not_visit: false,
}

export const PHONE = {
    number: "",
    type: "",
    area_code: "",
    country: "",
    extension: "",
}

export const PHONE_TYPES = ['Mobile', 'Home', 'Work', 'Other']
